import React from 'react';
import { Outlet } from 'react-router-dom';
import { isNativePlatform } from '../../utils/platform';

export const PublicLayout: React.FC = () => {
  const isNative = isNativePlatform();

  return (
    <div
      className={`min-h-screen flex items-center justify-center p-4 ${isNative ? 'pt-12' : ''}`}
      style={{
        backgroundColor: '#0a0a3a',
        backgroundImage: 'url(/Soni.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="w-full max-w-md">
        <Outlet />
      </div>
    </div>
  );
};

export default PublicLayout;
